/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { useTheme } from "@material-ui/core/styles";
import styled from "styled-components";

import { clearFacilities, fetchFacilities } from "../../slices/facilitiesSlice";

import StyledTextField from "../common/StyledTextField";

const StyledAutoComplete = styled(Autocomplete)`
  .MuiAutocomplete-input {
    color: ${(props) => props.theme.palette.primary.dark};
  }
`;

const FacilityAutoComplete = ({
  selectedFacility,
  handleChange,
  label,
  focusedLabel,
  width,
  error,
  useAlphaCodeTitle,
}) => {
  const theme = useTheme();
  const facilities = useSelector((state) => {
    return state.facilities.facilities;
  });

  const facilitiesFetching = useSelector((state) => {
    return state.facilities.isFetching;
  });

  const dispatch = useDispatch();

  const [isFocused, setIsFocused] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [open, setOpen] = useState(false);
  const loading = open && facilitiesFetching;

  const handleInputChange = ({ target: { value } }) => {
    setInputValue(value ? value : "");
    if (value.length > 2) {
      dispatch(fetchFacilities(value));
    } else if (value.length < 3 && facilities.length) {
      dispatch(clearFacilities());
    }
  };

  const filterOptions = createFilterOptions({
    stringify: (option) => {
      return option.slicCode + option.alphaCode + option.city;
    },
  });

  const getFacility = () => {
    if (selectedFacility && selectedFacility.id) {
      var facilityDisplayText = getFacilityDisplay(selectedFacility);
      return useAlphaCodeTitle
        ? { ...selectedFacility, name: facilityDisplayText }
        : selectedFacility;
    } else {
      return null;
    }
  };

  const getFacilityDisplay = (option) => {
    var slicCode = option.slicCode ? option.slicCode : "--";
    var alphaCode = option.alphaCode ? option.alphaCode : "--";
    return option.name + " (" + slicCode + "/" + alphaCode + ")";
  };

  const getLabel = () => {
    if (isFocused || (selectedFacility && selectedFacility.id)) {
      return focusedLabel ? focusedLabel : label;
    }
    return label;
  };

  return (
    <StyledAutoComplete
      value={getFacility()}
      filterOptions={filterOptions}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
        dispatch(clearFacilities());
      }}
      getOptionLabel={(option) => getFacilityDisplay(option)}
      noOptionsText={
        inputValue.length > 2
          ? "No results"
          : "Please enter at least 3 characters"
      }
      loading={loading}
      options={facilities ? facilities : []}
      style={width ? { width: width } : {}}
      onChange={(event, option) => handleChange(event, option)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      theme={theme}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label={getLabel()}
          error={error}
          variant="outlined"
          onChange={handleInputChange}
        />
      )}
    />
  );
};

export default FacilityAutoComplete;
